// @ts-nocheck

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PMGrid, TableWidget } from "../lib";
import { setStore } from "../store/appSlice";
import { MenuWidget } from "./MenuWidget";

import { useQualityCheckListQuery } from "../store/qualityCheckListSlice";
import { default as qualityCheckListFormatter } from "../transformations/qualityCheckListFormatter";
function ShipmentQualityList() {
    const [qualityCheckListSkip, setqualityCheckListSkip] = useState(true);
    const [qualityCheckListParams, setqualityCheckListParams] = useState({});
    const qualityCheckListQuery = useQualityCheckListQuery(qualityCheckListParams, { skip: qualityCheckListSkip });
    const dispatch = useDispatch();
    const qualityCheckListData = useSelector((states) => states?.appStore?.qualityCheckListData);

    const qualityCheckListSuccess = (data) => {
        savequalityCheckListData(data);
    };
    useEffect(() => {
        if (qualityCheckListQuery.isSuccess) {
            qualityCheckListSuccess(qualityCheckListQuery);
        } else if (qualityCheckListQuery.isError) {
            qualityCheckListSuccess(null);
        }
    }, [qualityCheckListQuery]);
    const qualityCheckList = (apiRespone) => {
        var data = apiRespone?.data || apiRespone;

        setqualityCheckListParams({ order_by: data ? data["-created_at"] : "-created_at" });
        setqualityCheckListSkip(false);
    };

    const savequalityCheckListData = (data) => {
        var formatedData = {
            ...qualityCheckListFormatter(data?.data || data, "qualityCheckListData"),
        };
        dispatch(setStore(formatedData));
    };

    useEffect(() => {
        qualityCheckList();
    }, []);

    const qualityCheckListReFetch = (tableParams) => {
        setqualityCheckListParams({ order_by: "-created_at", ...tableParams });
    };
    return (
        <div className="builder_wrapper">
            <MenuWidget data={{title:"View Stock Entries"}}>
                <PMGrid container={true} marginTop={2}>
                    <TableWidget
                        header="Previous Stock Entry"
                        showSerialNumber={false}
                        xs={12}
                        tableApi={qualityCheckListData || []}
                        updateTable={qualityCheckListReFetch}
                        columns={[
                            {
                                field: "shipment_date",
                                headerName: "Delivery Date",
                                type: "date",
                                sortable: false,
                                flex: 0.8,
                            },
                            { field: "created_at", headerName: "QC Date", type: "date", flex: 0.8, sortable: false },
                            {
                                field: "product_name",
                                headerName: "Product Name",
                                highlight: true,
                                flex: 1.4,
                                sortable: false,
                            },
                            { field: "supplier_name", headerName: "Supplier Name", flex: 1.5, sortable: false },
                            { field: "batch_no", headerName: "Batch Number", sortable: false },
                            { field: "quantity", headerName: "Total Qty", flex: 0.6, sortable: false },
                            { field: "leakage", headerName: "Leakage", flex: 0.6 },
                            { field: "blooted", headerName: "Bloated", flex: 0.6 },
                            { field: "other", headerName: "Other", flex: 0.5 },
                            { field: "defect_percentage", headerName: "Defective%", flex: 0.7, sortable: false },
                            {
                                field: "total_inwarded_qantity",
                                headerName: "Inward Qty",
                                flex: 0.8,
                                highlight: true,
                                sortable: false,
                            },
                            { field: "download_item", headerName: "", flex: 0.4, type: "download" },
                        ]}
                    ></TableWidget>
                </PMGrid>
            </MenuWidget>
        </div>
    );
}
export default ShipmentQualityList;
